import { project } from "./pages/project.module";
import { worker } from "./pages/worker.module";
import { invoiceList } from "./pages/invoiceList.module";
export const pages = {
  namespaced: true,
  modules: { project, worker, invoiceList },
};
